import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthed } from './auth';

const AdminGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const ok = isAuthed();
  if (!ok) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
};

export default AdminGuard;
